<template>
    <form-field v-bind="fieldProps">
        <date-range-input
            v-bind="inputProps"
            :openSide="openSide"
            :isSingle="isSingle"
            :dateFormat="dateFormat"
            :allowedDays="allowedDays"
            :minDate="minDate"
            :maxDate="maxDate"
            :iconCustomClass="iconCustomClass"
            @change="change($event)"
            @emitEvent="emitEvent($event, ['change'])"
        ></date-range-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'
    import FormPrefillingMixin from 'mixins/FormPrefillingMixin'

    export default {
        mixins: [FormFieldMixin, FormPrefillingMixin],
        props: {
            openSide: { type: String, default: 'left', validator: (value) => ['left', 'right'].includes(value) },
            appendToBody: { type: Boolean, default: false },
            isSingle: { type: Boolean, default: false },
            dateFormat: { type: String, default: undefined },
            allowedDays: {
                type: Array,
                default: undefined,
                validator: (value) => !value || value.every((v) => !isNaN(v) && v < 7),
            },
            minDate: { type: Date, default: undefined },
            maxDate: { type: Date, default: undefined },
            iconCustomClass: { type: String, default: 'picker-icon' },
        },
    }
</script>

<style scoped></style>
